
<div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">

    <button class="mx-2 badge text-muted"  ngbDropdownToggle> 
        {{selected?selected:"Offering"}} </button>
         <div class="dropdown-menu" ngbDropdownMenu >
          <button  *ngFor = 'let ofr of offerings' ngbDropdownItem  (click) = 'selected = ofr; browse(ofr)' >{{ofr}} </button>    
    </div>
      </div>